import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link, NavLink } from 'react-router-dom'
import logo from '../../assets/logo.png'
import { startLogout } from '../../redux/store/auth/thunks'

// import { startActivarNotificaciones, startSuscripcion } from '../../redux/store/pedidos/thunks'
// import { getAuth, signInAnonymously} from "firebase/auth";

export const Navbar2 = () => {

    const { status, displayName, perfil } = useSelector(state => state.auth);
    const dispatch = useDispatch();
  
    const logout = () => {
      dispatch(startLogout());
    }

    // const mandarNotificacion = () => {
    //   sendNotificationsNuevoPedido();
    // }

    // const fakeLogin = () => {
    //   signInAnonymously(getAuth()).then( usuario => console.log("Fake login: ", usuario))
    // }

    // const suscribirte = () => {
    //   dispatch(startSuscripcion());
    // }


  return (
    <>

<nav style={{backgroundColor: "#8fc74a"}} className="navbar navbar-expand-lg">
  <div className="container-fluid">
     <Link to='/'><img src={logo} className='navbar__logo' alt="logo" /></Link>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="fa-solid fa-bars"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">

      <ul className="navbar-nav me-auto mb-2 mb-lg-0">

        {/* <li className="nav-item"><NavLink className='nav-link' activeClassName="active" to='/produccion'>Producción</NavLink></li> */}
        {perfil !== "Seguimiento" && (<li className="nav-item"><NavLink className='nav-link' activeClassName="active" to='/produccion'>Producción</NavLink></li>)}
        {perfil !== "Seguimiento" && (<li className="nav-item"><NavLink className='nav-link' exact activeClassName="active" to='/' >Pendientes</NavLink></li>)}
        {perfil !== "Seguimiento" && (<li className="nav-item"><NavLink className='nav-link' activeClassName="active" to='/asignados'>Asignados</NavLink></li>)}
        {perfil !== "Seguimiento" && (<li className="nav-item"><NavLink className='nav-link' activeClassName="active" to='/completos'>Completos</NavLink></li>)}
        {perfil === "Administrador" ? (<li className="nav-item"><NavLink className='nav-link' activeClassName="active" to='/noPagados'>No Pagados</NavLink></li>) : null}
        {(perfil === "Repartidor" || perfil === "Administrador") ? (<li className="nav-item"><NavLink className='nav-link' activeClassName="active" to='/gastos'>Gastos</NavLink></li>) : null}
        {(perfil === "Empleado" || perfil === "Administrador" || perfil === "Sucursal" || perfil === "Vendedor") && (<li className='nav-item'><NavLink className='nav-link' activeClassName="active" to='/generar'>Generar</NavLink></li>)}
        {perfil !== "Seguimiento" && (<li className="nav-item"><NavLink id='estadisticasLink' className='nav-link' activeClassName="active" to='/estadisticas'>Estadísticas</NavLink></li>)}
        {(perfil === "Administrador" || perfil === "Vendedor") && (<li className="nav-item"><NavLink className='nav-link' activeClassName="active" to='/vendedores'>Vendedores</NavLink></li>)}
        {(perfil === "Administrador" || perfil === "Vendedor" || perfil === "Empleado" || perfil === "Sucursal" || perfil === "Seguimiento") && (<li className="nav-item"><NavLink className='nav-link' activeClassName="active" to='/clientes'>Clientes</NavLink></li>)}
        {(perfil === "Administrador" || perfil === "Seguimiento") && (<li className="nav-item"><NavLink className='nav-link' activeClassName="active" to='/seguimiento'>Seguimiento</NavLink></li>)}
        {perfil === "Administrador" && (<li className="nav-item"><NavLink className='nav-link' activeClassName="active" to='/auth/register'>Registrar Usuario</NavLink></li>)}
        <li style={{marginLeft: "50px"}} className='nav-item'>
        {status === "authenticated" ? (
              <div className='navbar__userInfo'>
                <p>{displayName} </p>
                <Link
                  to='/'
                  className='navbar__logoutButton'
                  onClick={logout}>
                  Cerrar Sesión
                </Link>
              </div>
            ) : null
            }   
        </li>

      </ul>

      {/* <button onClick={mandarNotificacion}>Notificaciones</button> */}
      {/* <button onClick={fakeLogin}>Login</button>
      <button onClick={suscribirte}>Suscribirte</button> */}
        
            
    </div>
  </div>
</nav>

    </>
  )
}
